// ABOUTME: Keep-warm layer for the pre-tap hold: keeps the footer's WebGL visualizer drawing under the opaque mic CTA, so the reel <video>
// ABOUTME: is never the ONLY animating surface (suspected cause of the Windows hybrid-GPU decoder hitch). Escape hatch: localStorage versai_no_warm_canvas=1.

import React from 'react';

/** Dev/ops hatch: `versai_no_warm_canvas=1` switches the keep-warm layer off after a reload (never turns anything on). */
export const WARM_OFF_KEY = 'versai_no_warm_canvas';

/**
 * Near-transparent, NOT hidden: the owner's positive test used a visible composited canvas, and `visibility:hidden` / `opacity:0` are
 * unproven (a browser may skip compositing them, which would defeat the point). Under the 82 %-opaque CTA this is below one colour step.
 */
export const WARM_OPACITY = 0.02;

export function warmCanvasOff() {
  try { return window.localStorage.getItem(WARM_OFF_KEY) === '1'; } catch { return false; }
}

/**
 * Wraps the dock's own core (already clipped to the slot's circle by the caller) in an inert layer the opaque CTA paints over.
 * It exists only while the CTA does: the tap unmounts it before the visible dots mount, so there is never more than one visualizer
 * canvas (CavalryViz binds one shared WebGL target; two at once race).
 */
export default function WarmCore({ children }) {
  if (warmCanvasOff()) return null;
  return (
    <div
      data-vf="warm"
      aria-hidden="true"
      className="absolute pointer-events-none"
      style={{ inset: 0, opacity: WARM_OPACITY, pointerEvents: 'none' }}
    >
      {children}
    </div>
  );
}
